module.exports = __webpack_public_path__ + "img/our-projects.10c962b7.webp";